<template>
<div style="margin-top:20px">
<div role="heading" aria-label="קהילה מקצועית למוסיקאים חובבים" aria-level="1" class="header-subtitle">קהילה מקצועית למוסיקאים חובבים</div>
	<div class="login-message">
		<div>לנגן או לשיר בהרכב בהנחיה מקצועית מלאה.</div>
		<div>!בואו לנגן איתנו</div>
	</div>
	<div class="header-login-info2" v-if="loginState == 1">
		<p>פרטיך נרשמו, נפנה אליך בהקדם</p>
		<p>תודה</p>
	</div>
	<div class="header-login-info2" v-if="loginState == 0">
		<div class="login-input-line errorMessage" >
			{{validationMessage}}
		</div>
		<div class="header-login-input-wrapper2">
			<div class="header-login-input-select2">
				<select option v-on:keyup.enter="focusNext(1)" v-if="true" :id="getUid('Branch')" :title="getUid('Branch')"
							v-model:value="branchInput"
							@focus="selectFocus" @blur="selectBlur" @change="selectChange">
					<option>סניף</option>
					<option>מרכז (תל אביב)</option>
					<option>צפון (חיפה)</option>
				</select>
			</div>		

			<input class="header-login-input2" autocomplete="off" v-on:keyup.enter="focusNext(2)" placeholder="שם מלא" @focus="onNameInput($event.target.value)" v-bind:value="nameInput" :id="getUid('nameInput')"  @input="onNameInput($event.target.value)" />
		
			<input class="header-login-input2"
			v-on:keyup.enter="focusNext(4)"
			  :id="getUid('emailInputID')"
						autocomplete="off"
						placeholder="אימייל"
						v-bind:value="emailInput"
						 @input="onEmailInput($event.target.value)" />
		<input v-on:keyup.enter="focusNext(1)"  dir="ltr" class="header-login-input2" :id="getUid('phoneInputID')"  autocomplete="off" placeholder="נייד"  v-bind:value="phoneInput" @focus="onPhoneInput($event.target.value)" @input="onPhoneInput($event.target.value)" />


			<div class="header-login-input-select2">
				<select option v-on:keyup.enter="focusNext(2)" v-if="true" :id="getUid('Select')" :title="getUid('Select')"
							v-model:value="instrumentInput"
							@focus="selectFocus" @blur="selectBlur" @change="selectChange">
					<option>כלי נגינה</option>
					<option>גיטרה חשמלית</option>
					<option>גיטרה אקוסטית</option>
					<option>בס</option>
					<option>קלידים</option>
					<option>חליליות</option>
					<option>סקסופון אלט</option>
					<option>סקסופון טנור</option>
					<option>סקסופון בריטון</option>
					<option>סקסופון סופרן</option>
					<option>קלרינט</option>
					<option>מפוחית</option>
					<option>חליל צד</option>
					<option>חצוצרה</option>
									<option>טרומבון</option>
					<option>תופים</option>
					<option>כלי הקשה</option>
					<option>כלי פריטה אחרים</option>
					<option>כלי קשת</option>
					<option>שירה</option>
					<option>אני רב כלי</option>
				</select>
				<select style='color:"#FF632B";' v-on:keyup.enter="focusNext(5)"  v-if="auditionType == 'Ensemble'" :id="getUid('Select')"
							v-model:value="instrumentInput"
							@focus="selectFocus" @blur="selectBlur" @change="selectChange">
					<option>שירה</option>
				</select>
			</div>		
				<label class="header-login-next-button2"
					v-on:click="registerUser()">שלח</label>
</div>
	
					</div>
					</div>
</template>

<script>
import axios from 'axios'
import VueScrollTo from 'vue-scrollto'
var APIbase = "https://yard-bands.herokuapp.com"
export default {
	components: {},
	props: ['auditionType','uid'],
	created() {
		console.log(this.auditionType);
		if (this.auditionType == 'Ensemble') {
			this.instrumentInput = 'שירה'
		}
	},
	data() {
		return {
			branchInput: "סניף",
			nameInput : "",
			instrumentInput : "כלי נגינה",
			emailInput : "",
			phoneInput : "",
			validationMessage : "",
			loginState: 0,
			refreshId:0,
			isMobile: false
		}
	},
	mounted() {
		this.isMobile = window.matchMedia('(max-width: 500px)').matches;
	},
	watch: {
		instrumentInput: function (val) {
			if (val === "כלי נגינה") {
				document.getElementById(this.getUid('Select')).style.color = "#c7b7a5";
			}
			this.$forceUpdate();
		},
		branchInput: function (val) {
			if (val === "סניף") {
				document.getElementById(this.getUid('Branch')).style.color = "#c7b7a5";
			}
			this.$forceUpdate();
		}
	},
	methods: {
	getUid(suffix) {
		return this.uid + suffix;
	},
	selectFocus(e) {
		if (this.isMobile) { return; }
		const el = e.target;
		el.style.background='black';
		el.style.color='#c7b7a5';
		el.size=6;
		el._oldInlineHeight = el.style.height;
		el.style.height='190px';
	},
	selectBlur(e) {
		if (this.isMobile) { return; }
		const el = e.target;
		el.style.background='black';
		el.style.color='#FF632B';
		el.size=1;
		if (el._oldInlineHeight) {
			el.style.height = el._oldInlineHeight;
		} else {
			el.style.height = '';
		}
		el._oldInlineHeight = undefined;
	},
	selectChange(e) {
		const el = e.target;
		if (this.isMobile) {
			el.size=1; // ensure native popup closes
			return;
		}
		el.style.background='transparent';
		el.size=1;
		// remove forced height when selection is made
		if (el._oldInlineHeight) {
			el.style.height = el._oldInlineHeight;
		} else {
			el.style.height = '';
		}
		el._oldInlineHeight = undefined;
		el.blur();
	},
	focusNext(num) {
		if (num == 1) {
			document.getElementById(this.getUid('nameInput')).focus();
		}
		if (num == 2) {
			document.getElementById(this.getUid('Select')).focus();
		}
		else if (num == 3) {
		 document.getElementById(this.getUid('emailInputID')).focus();
		}
		else if (num == 4) {
		 document.getElementById(this.getUid('phoneInputID')).focus();
		}
		else {
			this.registerUser();
		}
	},
		registerUser(){
			this.validateInput()
			if (this.validationMessage === "") {
					var site = 'center';
					if (this.branchInput == 'צפון (חיפה)')
					{
						site = 'north';
					}
					axios.post(APIbase+'/v2/create_user_for_detailes',{
							'name':this.nameInput,
							'instrument':this.instrumentInput,
							'email':this.emailInput,
							'phone':this.phoneInput,
							'site': site,
							'audition_type':this.auditionType
						}).then(response => 																								{																						
						this.loginState = 1
						if (site == 'center') {
							window.location.href = "https://yardbands.com/detailstelaviv";
						}
						else {
							window.location.href = "https://yardbands.com/detailshaifa";
						}
					})

				
			}
		},
		onEmailInput(val){
			var local_tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a_z`{|}~])*/;
			var domain_tester = /[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+/;
			
			var new_emailParts = val.split('@');

			if (new_emailParts.length < 2) {
				if ( (val.length==0 || local_tester.test(val)) && val.length <= 64) {
					this.emailInput = val;
				}
			}
			else if (new_emailParts.length == 2) {
				var old_emailParts = this.emailInput.split('@');
				var result = "";
				if ( (new_emailParts[0].length>0  && !local_tester.test(new_emailParts[0])) || new_emailParts[0].length > 64) {
					result = old_emailParts[0]; 
				}
				else {
					result = new_emailParts[0];
				}
				if ( new_emailParts[1] > 255) {
					if (old_emailParts.length <2 ) {
						result = result + "@";
					}
					else {
						result = result + "@" + old_emailParts[1].trim();
					}
				}
				else {
					result = result + "@" + new_emailParts[1].trim();
				}
				this.emailInput = result.trim();
			}
			this.$forceUpdate();
		},
		onNameInput(val){
			let forbiddenChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
			let result = Array.from(val).filter(f=> !forbiddenChars.includes(f)).join('');
			if (result.length < val.length) {
				this.validationMessage = "השארת פרטים בעברית בלבד"
			}else {
				this.validationMessage = ""
			}

			this.nameInput = result;
			this.$forceUpdate();
		},
		onPhoneInput(val){

			let allowedChars = "0123456789";
			let result = Array.from(val).filter(f=> allowedChars.includes(f)).join('');
			if (result.length > 10) {
				this.phoneInput = result.substring(0,10);
			}
			else if (result.length <= 2) {
				this.phoneInput = "05";
				this.$forceUpdate();
				window.setTimeout(function() {
					var InputElement = document.getElementById(this.getUid('phoneInputID'));
					InputElement.setSelectionRange(2, 2);
            	}, 1);
			}
			else if (!result.startsWith('05')) {
				var InputElement = document.getElementById(this.getUid('phoneInputID'));
				InputElement.setSelectionRange(this.phoneInput.length, this.phoneInput.length);
			}
			else {
				this.phoneInput = result;
			}
			this.$forceUpdate();
			
		},
		instrumentSelected(val){

		},
		validateEmail() {
			var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

				var emailParts = this.emailInput.split('@');

				if (emailParts.length !== 2) {
					return 1;
				}

				var account = emailParts[0];
  				var address = emailParts[1];

 				if (account.length > 64 || address.length > 255) {
					return 2;
				}
			        var domainParts = address.split('.');
  
			        if (domainParts.some(function (part) {
                                        return part.length > 63;
                                })) {
					return 3;
				}
				if (!tester.test(this.emailInput)) {
					return 4;
				}
				return 0;

		},
		validateInput() {
			var re = /\S+@\S+\.\S+/;
			if (this.nameInput === "") {
				this.validationMessage = "נא להקליד שם ושם משפחה"
			}
			else if (this.instrumentInput === "כלי נגינה"
			|| this.instrumentInput === "כלי נגינה ראשי") {
				this.validationMessage = "נא לבחור כלי נגינה ראשי";
			}
			else if (this.emailInput === "") {
				this.validationMessage = "נא להכניס אימייל"
			}
			else if (this.validateEmail() != 0) {
				this.validationMessage = "כתובת האימייל שהוקלדה אינה חוקית"
			}
			else if (this.phoneInput === "") {
				this.validationMessage = "נא להכניס מספר נייד"
			}
			else if (this.phoneInput.length != 10) {
				this.validationMessage = "מספר הנייד צריך להכיל 10 ספרות"
			}
			else {
				this.validationMessage = ""
			}
			this.$forceUpdate();
		}


	}

}
</script>


// WEBPACK FOOTER //
// TalkToMeHeader.vue?08c87096